import { motion } from "framer-motion";
import { MessageCircle, MapPin } from "lucide-react";
import { buildWhatsAppLink } from "@/lib/api";
import { BRAND } from "@/lib/brand";
import { useMobilI18n } from "@/lib/mobilI18n";
import MobilRequestForm from "@/components/mobil/MobilRequestForm";

export default function MobilContact({ whatsappNumber, onSubmitted }) {
  const { m } = useMobilI18n();
  return (
    <section id="contacte-externs" data-testid="mobil-contact" className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#fdfcf9]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-100px" }} transition={{ duration: 0.7 }} className="lg:col-span-5">
          <p className="uppercase tracking-[0.28em] text-xs text-[#3e664c] mb-4 font-medium">{m.contact.eyebrow}</p>
          <h2 className="font-display text-4xl md:text-5xl tracking-[-0.02em] leading-[1.05]">{m.contact.title}</h2>
          <p className="mt-6 text-[#5C544F] leading-relaxed max-w-md">{m.contact.desc}</p>
          <a
            href={buildWhatsAppLink(whatsappNumber, m.contact.whatsappText)}
            target="_blank" rel="noreferrer" data-testid="mobil-contact-whatsapp"
            className="mt-8 inline-flex items-center gap-3 px-7 py-3.5 rounded-full border border-[#3e664c] text-[#3e664c] hover:bg-[#3e664c] hover:text-[#fdfcf9] transition-colors text-sm uppercase tracking-[0.18em]"
          >
            <MessageCircle size={16} /> {m.contact.whatsapp}
          </a>
          <div className="mt-10 space-y-2 text-sm text-[#5C544F]">
            <p data-testid="mobil-contact-phone">{BRAND.phoneInfo}</p>
            <p>{BRAND.ownerEmail}</p>
            <p className="flex items-center gap-2"><MapPin size={14} className="text-[#3e664c]" /> Sant Cugat del Vallès · Barcelona</p>
          </div>
        </motion.div>
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.8 }}
          className="lg:col-span-7 bg-white rounded-3xl border border-[#eae0df] p-6 md:p-10 shadow-[0_8px_30px_rgb(42,36,33,0.06)]">
          <p className="uppercase tracking-[0.28em] text-[10px] text-[#3e664c] mb-2">{m.form.eyebrow}</p>
          <h3 className="font-display text-3xl tracking-tight mb-2">{m.form.title}</h3>
          <p className="text-sm text-[#5C544F] mb-6">{m.form.desc}</p>
          <MobilRequestForm whatsappNumber={whatsappNumber} testPrefix="mobil-form" onDone={onSubmitted} />
        </motion.div>
      </div>
    </section>
  );
}
